import debug from "debug";
import * as THREE from "three";
import { Raycaster } from "three";
import Experience from "../Experience.js";
import { apiUrl, ffUrl, errorUrl, assetURL, newHeader } from "./config";
import { getViewDesignSourceFromPath } from "../../lib/utils/viewDesignRoute.js";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import EventEmitter from "../Utils/EventEmitter.js";
import itemsInScene from "./getSceneInfo.js";
import MakeShape from "./MakeShape.js";
import AddShape from "./MakeGroup.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { BomData } from "../../Components/BOM/BomData.js";
import Ctl from "./createCtls.js";
import { BomTable } from "../../Components/BOM/BomTable.js";
import { PowerTable } from "../../Components/PowerTable/PowerTable.js";
import { PowerTableData } from "../../Components/PowerTable/PowerTableData.js";
import { GlobalTableContainer } from "../../Components/Tables/GlobalTable/GlobalTableContainer.js";
import makeShapeConfig from "./MakeShapeConfig.js";
import Gsg from "./Gsg.js";
import MoveObject from "../Manipulation/MoveObject.js";
import DeleteObject from "../ObjectManagement/DeleteObject.js";
import ShapeManager from "../../Components/ShapeManager/ShapeManager.js";
import MakeParts from "./MakeParts.js";
import DeleteAuto from "../ObjectManagement/DeleteAuto.js";
import MakeGsg from "./MakeGsg.js";
import MakeGridHelper from "./MakeGridHelper.js";
import MakeControls from "./MakeControls.js";
import {
  specificPartNumbers,
  specificFormFactors,
} from "./SpecificDataImages.js";
import DisabledConfigureCat from "./DisabledConfigureCat.js";
import { TitleBlock } from "../../Components/TitleBlock/TitleBlock.js";
import { HelpMenu } from "../../Components/HelpMenu/Helpmenu.js";
import { SliderTransparency } from "../../Components/Sidebar/SliderTransparency.js";
import Enable3DMode from "./Enable3DMode.js";
import { GlobalModal } from "../../Components/GlobalModal/GlobalModal.js";
import DetectCollisionGsg from "../ObjectManagement/DetectCollisionGsg.js";
import PortDirection from "../ObjectManagement/PortDirection.js";
import MakeWalls from "../GeometryManagement/MakeWalls/MakeWalls.js";
import MakeLids from "../GeometryManagement/MakeLids/MakeLids.js";
import { ContextMenuModalData } from "../../Components/ContextMenu/ContextMenuModalData.js";
import TextBoxManager from "../../Components/TextBox/TextBoxManager.js";
import ObjectIdMap from "../../Components/UndoRedoManager/ObjectIdMap.js";
import FunctionsCfgData from "./FunctionsCfgData.js";
import ContextMenu from "../../Components/ContextMenu/ContextMenu.js";
import CopyPasteManager from "../ObjectManagement/CopyPasteManager.js";
import SParamModal from "../../Components/ContextMenu/SParamModal.js";
import { DarkModeController } from "../../Components/DarkModeController/DarkModeController.js";

const log = debug("app:fn");
const logg = debug("app:fnc");

const UPDATE_MODAL_COOKIE_NAME = "xmw_update_notice_v1";

function getCookie(name) {
  if (typeof document === "undefined") return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
  return null;
}

function setCookie(name, value, days) {
  if (typeof document === "undefined") return;
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${encodeURIComponent(
    value
  )};${expires};path=/;SameSite=Lax`;
}

export default class Functions {
  constructor(hoverEnabled, clickEnabled) {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.eventHub = this.experience.eventHub;
    this.getSceneJson = new itemsInScene();
    this.makeGsg = new MakeGsg(this.experience);
    this.detectCollisionGsg = new DetectCollisionGsg(this.experience);
    this.makeControls = new MakeControls(this.experience);
    this.makeWalls = new MakeWalls(this.experience);
    this.makeLids = new MakeLids(this.experience);
    this.textBoxManager = new TextBoxManager(this.experience);
    this.deleteAuto = new DeleteAuto(this.experience);
    this.deleteObject = new DeleteObject(this.experience);
    this.modeValue = "hybrid";
    this.contextMenu = new ContextMenu(this.experience);
    this.copyPasteManager = new CopyPasteManager(this.experience);
    this.darkModeController = new DarkModeController(this.experience);

    this.objects = [];
    this.objectsToMove = [];
    this.connectionPoints = [];
    this.objectsAndPlane = [];
    this.originalMaterials = [];
    this.resources = this.experience.resources;
    this.debug = this.experience.debug;
    this.resources = this.experience.resources;
    this.resource = this.resources.items.object;
    this.sizes = this.experience.sizes;
    this.camera = this.experience.camera;
    this.canvas = this.experience.canvas;
    this.renderer = this.experience.renderer;
    this.meshAndTexture = [];
    this.meshAndPurTexture = [];
    this.Meshes = [];
    this.housings = [];
    this.ctlMeshes = [];
    this.housingsAndPlane = [];
    this.ctlToGroupMap = new Map();
    this.singleDisabled = false;
    this.eventEmitter = new EventEmitter();
    this.isDragging = false;
    this.stopClickOnCt = false;
    window.sharedEventEmitter = this.eventEmitter;

    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("fox");
    }
    this.raycaster = new Raycaster();
    this.rayOrigin = new THREE.Vector3(0, 0, 0);
    this.rayDirection = new THREE.Vector3(0, 0, 0);
    this.rayDirection.normalize();
    this.raycaster.set(this.rayOrigin, this.rayDirection);
    this.intersectedObjects = [];
    this.mouse = new THREE.Vector2();
    this.blockSingleDrag = false;

    window.addEventListener("mousemove", (event) => {
      if (event.button !== 0) return; // Exit if not left click
      this.mouse.x = (event.clientX / this.sizes.reSize.width) * 2 - 1;
      this.mouse.y = -(event.clientY / this.sizes.reSize.height) * 2 + 1;
    });

    this.dragging = false;
    this.clone = null;
    this.haha = false;
    this.offset = new THREE.Vector3();
    this.dragging = false;
    this.clone = null;
    this.haha = false;
    this.offset = new THREE.Vector3();
    this.lastMouseup = new THREE.Vector3();

    this.makeGridHelper = new MakeGridHelper(this);
    this.bomData = new BomData(this.experience);
    this.tableBOM = new BomTable(this.experience);
    this.powerTable = new PowerTable(this.experience);
    this.powerTableData = new PowerTableData(this.experience);
    
    this.titleBlock = new TitleBlock(this.experience);
    this.helpMenu = new HelpMenu(this.experience);
    this.sliderTransparency = new SliderTransparency(this.experience);
    this.enable3DMode = new Enable3DMode(this.experience);
    this.sliderTransparency.initSliders();
    this.globalModal = new GlobalModal(this.experience);
    this.portDirection = new PortDirection(this.experience);

    // Clear meshAndTexture/meshAndPurTexture on deleteScene to prevent memory leak when switching 2D/3D
    this._clearMeshAndTextureOnDelete = this.clearMeshAndTextureOnDelete.bind(this);
    this.eventHub.on("deleteScene", this._clearMeshAndTextureOnDelete);
    this.contextMenuModalData = new ContextMenuModalData(this.experience);
    this.objectIdMap = new ObjectIdMap(this.experience);
    this.sParamModal = new SParamModal(this.experience);
    this.globalTableContainer = new GlobalTableContainer(this.experience);

    // rAF throttle + change guard to avoid spamming the bus
    this._pmRafPending = false;
    this._lastPointerWorld = { x: null, y: null, z: null };

    this.showFirstVisitUpdateModalIfNeeded();

    // pick the canvas/DOM element you render to
    const canvasEl =
      this.canvas ||
      this.renderer?.domElement ||
      document.querySelector("canvas.webgl") ||
      document.getElementById("modelCanvas");

    const emitPointerWorld = (nx, ny) => {
      // normalize device coords -> raycast
      this.mouse.x = nx;
      this.mouse.y = ny;
      this.raycaster.setFromCamera(this.mouse, this.camera.instance);

      // Prefer the layout base plane if present, else fall back to scene children
      const basePlane = this.experience?.world?.basePlane?.mesh;
      const hits = basePlane
        ? this.raycaster.intersectObject(basePlane, true)
        : this.raycaster.intersectObjects(this.scene.children, true);

      if (!hits || !hits.length) return;

      const p = hits[0].point;

      // Keep snapping consistent with this branch (Math.floor used above)
      const x = Math.floor(p.x);
      const z = Math.floor(p.z);
      const y = -1.5; // build plane height used for placement

      // only emit when the snapped cell changes
      if (
        x !== this._lastPointerWorld.x ||
        y !== this._lastPointerWorld.y ||
        z !== this._lastPointerWorld.z
      ) {
        this._lastPointerWorld = { x, y, z };
        this.eventHub.emit("globalPointerWorld", { x, y, z, source: "Functions" });
      }
    };

    if (canvasEl) {
      canvasEl.addEventListener(
        "pointermove",
        (e) => {
          if (this._pmRafPending) return;
          this._pmRafPending = true;

          requestAnimationFrame(() => {
            this._pmRafPending = false;

            // use the same dims you already use elsewhere
            const w = this.sizes?.reSize?.width ?? window.innerWidth;
            const h = this.sizes?.reSize?.height ?? window.innerHeight;

            const nx = (e.clientX / w) * 2 - 1;
            const ny = -(e.clientY / h) * 2 + 1;

            emitPointerWorld(nx, ny);
          });
        },
        { passive: true }
      );
    }

    // FILTER SEARCH FOR DRAG TABLE
    const filterTable = () => {
      const filterValue = filterInput.value.toLowerCase();
      const rows = tbody.getElementsByTagName("tr");

      for (let i = 0; i < rows.length; i++) {
        let rowMatchesFilter = false;

        const cells = rows[i].getElementsByTagName("td");

        for (let j = 0; j < cells.length; j++) {
          const cell = cells[j];
          if (cell.textContent.toLowerCase().indexOf(filterValue) > -1) {
            rowMatchesFilter = true;
            break;
          }
        }
        rows[i].style.display = rowMatchesFilter ? "" : "none";
      }
      this.updateBackgroundContainer();
    };

    // Add your JavaScript code here
    const url = assetURL;

    this.fetchFromDataVault = (requestEvent, id, responseEvent) => {
      return new Promise((resolve, reject) => {
        const responseHandler = (data) => {
          log(`Received data for ${responseEvent}:`, data);
          resolve({
            ok: true,
            headers: new Headers(),
            json: () => Promise.resolve({ data }),
          });
          this.eventHub.off(responseEvent, responseHandler);
        };

        this.eventHub.on(responseEvent, responseHandler);
        log(`Emitting ${requestEvent} with id:`, id);
        this.eventHub.emit(requestEvent, id);
      });
    };

    async function getCachedImage(imagePath) {
      //console.log("Fetching image:", imagePath);

      return new Promise((resolve) => {
        const dbRequest = indexedDB.open("ImageCacheDB");

        dbRequest.onsuccess = () => {
          const db = dbRequest.result;
          const transaction = db.transaction("images", "readonly");
          const store = transaction.objectStore("images");

          //console.log("Checking IndexedDB for:", imagePath);
          const request = store.get(imagePath);

          request.onsuccess = async () => {
            if (request.result && request.result.blob) {
              //console.log("Image found in cache:", imagePath);
              resolve(URL.createObjectURL(request.result.blob));
            } else {
              console.warn(
                "Image not found in cache, fetching from API:",
                imagePath
              );
              resolve(await fetchAndCacheImage(imagePath));
            }
          };

          request.onerror = () => {
            console.error("IndexedDB request failed for:", imagePath);
            resolve(fetchAndCacheImage(imagePath));
          };
        };
      });
    }

    async function fetchAndCacheImage(imagePath) {
      try {
        const response = await fetch(imagePath);
        if (!response.ok) {
          throw new Error(
            `Image fetch failed: ${response.status} ${response.statusText}`
          );
        }

        const blob = await response.blob();
        //("Fetched image from API:", imagePath);

        const dbRequest = indexedDB.open("ImageCacheDB");

        dbRequest.onsuccess = () => {
          const db = dbRequest.result;
          const transaction = db.transaction("images", "readwrite");
          const store = transaction.objectStore("images");

          // Store the image as a Blob
          store.put({ url: imagePath, blob: blob });

          //console.log("Image cached in IndexedDB:", imagePath);
        };

        return URL.createObjectURL(blob);
      } catch (error) {
        console.error("Failed to fetch and cache image:", imagePath, error);
        return ""; // Return empty string or placeholder image
      }
    }

    // Assume 'scene' is your THREE.Scene object
    function countMeshesByPartNumber(scene) {
      const partNumberCounts = {};
      scene.traverse((object) => {
        if (object instanceof THREE.Mesh && object.userData.pn) {
          const pn = object.userData.pn;
          partNumberCounts[pn] = (partNumberCounts[pn] || 0) + 1;
        }
      });
      log("Part number counts:", partNumberCounts);
      return partNumberCounts;
    }

    const tabsContainer = document.getElementById("tabs-container");
    tabsContainer.style.display = "flex";
    tabsContainer.style.marginTop = "5px";
    tabsContainer.style.marginLeft = "5px";
    tabsContainer.innerHTML = "";

    this.layoutMode = "hybrid";
    this.tableIsHere = false;
    const table = document.createElement("table");
    table.classList.add("drag-table");
    const thead = document.createElement("thead");
    thead.classList.add("dragTable-head");
    const tbody = document.createElement("tbody");
    tbody.classList.add("dragTable-body");

    // Create table header
    this.itemsInScene = [];
    // INITIAL TABLE WITHOUT BOM DATA

    this.prices = [];
    window.table = table;

    tabsContainer.appendChild(table);

    //ADDING BACKGROUND CONTAINER FOR DRAG TABLE
    this.dragTableContainer = document.createElement("div");
    this.dragTableContainer.classList.add("drag-table-container");

    const filterDiv = document.createElement("div");
    filterDiv.classList.add("drag-table-filter");

    const filterInput = document.createElement("input");
    filterInput.classList.add("drag-table-input");
    filterInput.setAttribute("type", "text");
    filterInput.setAttribute("id", "filterInput");
    filterInput.setAttribute("placeholder", "Search");
    filterInput.oninput = filterTable;

    const buttonContainer = document.createElement("div");
    buttonContainer.classList.add("drag-table-btn-container");

    const btnXMW = document.createElement("button");
    btnXMW.classList.add("drag-table-xmw-btn");
    btnXMW.textContent = "X-MWBlock";

    const btnConfig = document.createElement("button");
    btnConfig.classList.add("drag-table-cfg-btn");
    btnConfig.textContent = "Configurable";
    btnConfig.style.marginLeft = "5px";

    btnXMW.addEventListener("click", function () {
      this.dragTableContainer.style.display = "block";
      table.style.display = "block";
      btnXMW.disabled = true;
      btnXMW.style.backgroundColor = "#008CBA";
      btnXMW.style.color = "white";
      btnConfig.style.backgroundColor = "";
      btnConfig.style.color = "";
    });

    btnConfig.addEventListener("click", () => {
      this.showConfModal(this.myTableData.headers);
      this.dragTableContainer.style.display = "none";
      table.style.display = "none";
    });

    buttonContainer.appendChild(btnXMW);
    buttonContainer.appendChild(btnConfig);

    filterDiv.appendChild(filterInput);
    this.dragTableContainer.appendChild(filterDiv);
    this.dragTableContainer.appendChild(buttonContainer);

    this.updateBackgroundContainer = () => {
      const tableRect = table.getBoundingClientRect();
      log("Table dimensions:", {
        width: tableRect.width,
        height: tableRect.height,
        top: tableRect.top,
        left: tableRect.left,
      });

      if (this.dragTableContainer) {
        this.dragTableContainer.style.width = `${tableRect.width + 30}px`;
        this.dragTableContainer.style.height = `${tableRect.height + 60}px`;
        this.dragTableContainer.style.top = `${tableRect.top - 45}px`;
        this.dragTableContainer.style.left = `${tableRect.left - 15}px`;
      }
    };
    this.updateBackgroundContainer();

    const headerRow = document.createElement("tr");
    let row;
    (async () => {
      try {
        const response = await this.fetchWithAuthHeaders(newHeader);

        if (!response.ok) throw new Error("Failed to fetch tabs data");

        let tabsData = await response.json();

        // Sort tabsData based on the "index" property
        tabsData.sort((a, b) => a.index - b.index);

        for (let i = 0; i < tabsData.length; i++) {
          const tab = tabsData[i];
          log("tabs data", tab);

          // Create tab button
          const tabButton = document.createElement("div");
          tabButton.setAttribute("referenced-Tab", `tab${tab.index}`);
          tabButton.textContent = tab.groupName;
          tabButton.classList.add("tabButton");
          tabsContainer.appendChild(tabButton);

          // Create tab content
          const tabContent = document.createElement("div");
          tabContent.id = `tab${tab.index}`;
          tabContent.classList.add("tab-content");
          if (i === 0) {
            tabContent.style.display = "flex";
            tabButton.classList.add("active");
          }

          // Create categories under the tab
          tab.categories.sort((a, b) => a.index - b.index);
          for (let j = 0; j < tab.categories.length; j++) {
            const category = tab.categories[j];
            const categoryButton = document.createElement("button");
            categoryButton.classList.add("categoryButton");
            categoryButton.style.backgroundImage = `url(${url}${category["Category Image"]})`;
            categoryButton.setAttribute("catID", category.id);

            const tooltip = document.createElement("div");
            tooltip.classList.add("tooltip-text");
            tooltip.innerText = category["Category Name"];
            categoryButton.appendChild(tooltip);

            categoryButton.addEventListener("mouseover", () => {
              tooltip.style.opacity = "1";
              tooltip.style.transform = "scale(1)";
              const rect = categoryButton.getBoundingClientRect();
              const tooltipRect = tooltip.getBoundingClientRect();

              // Calculate left position
              let left = rect.left + rect.width / 2 - tooltipRect.width / 2;
              // Ensure the tooltip doesn't overflow the viewport
              if (left < 0) {
                left = 0;
              } else if (left + tooltipRect.width > window.innerWidth) {
                left = window.innerWidth - tooltipRect.width;
              }

              // Set tooltip position
              tooltip.style.left = `${left + window.pageXOffset}px`;
              tooltip.style.top = `${rect.bottom + window.pageYOffset}px`;
            });

            categoryButton.addEventListener("mouseout", () => {
              tooltip.style.opacity = "0";
              tooltip.style.transform = "scale(0)";
            });

            // Add event listener for mousedown on category button
            categoryButton.addEventListener("mousedown", (event) => {
              this.eventHub.emit("alignPlane");
              

              tooltip.style.opacity = "0";
              tooltip.style.transform = "scale(0)";
              document.dispatchEvent(new CustomEvent("closeModal"));
              document
                .getElementById("titleblock")
                .classList.remove("bold-icon");
              this.globalTableContainer.hideGlobalTableContainer();
              if (this.modal) {
                this.modal.style.display = "none";
              }
              this.stopClickOnCt = true;
              this.buttonHasBeenDragged = true;
              const dragTable = document.querySelector(".drag-table");
              if (dragTable) {
                dragTable.style.display = "none";
              }
              if (document.getElementById("dynamicSearchTable")) {
                document.getElementById("dynamicSearchTable").style.display =
                  "none";
              }
              this.buttonDrag = true;
              this.Meshes.forEach((object) => {
                if (object.isSelected) {
                  object.isSelected = false; // Reset selected state
                  object.material.color.set(object.originalColor); // Revert to original color
                }
              });
              var collisionDetected = false;
              thead.innerHTML = "";
              tbody.innerHTML = "";
              headerRow.innerHTML = "";

              // BUILDING TABLE FROM CATEGORY WITH GET REQUEST ON CAT ID
              const catId = categoryButton.getAttribute("catID");
              this.catId = catId;
              const url = `${apiUrl}/${catId}`;
              console.log(catId);
              // Make the GET request using fetch
              this.fetchFromDataVault("requestCategory", catId, "categoryData")
                .then((response) => {
                  if (!response.ok) {
                    this.dragTableContainer.style.display = "none";
                    throw new Error(`HTTP error! Status: ${response.status}`);
                  }
                  return response.json();
                })
                .then((data) => {
                  if (DisabledConfigureCat.includes(catId)) {
                    btnXMW.style.display = "none";
                    btnConfig.style.display = "none";
                  } else {
                    btnXMW.style.display = "block";
                    btnConfig.style.display = "block";
                  }
                  // Handle the response data here
                  this.myTableData = data.data;

                  this.myTableData.headers.forEach((header) => {
                    const th = document.createElement("th");
                    th.textContent = header.lbl;
                    headerRow.appendChild(th);
                    th.style.textAlign = "center";
                    th.style.padding = "5px";

                    const sortIcon = document.createElement("img");
                    sortIcon.setAttribute("src", "./imgs/sort_asc.png");
                    sortIcon.style.marginLeft = "5px";
                    sortIcon.style.cursor = "pointer";

                    th.appendChild(sortIcon);
                    let isAscending = true;

                    th.addEventListener("click", () => {
                      resetAllSortIcons();
                      isAscending = !isAscending;

                      sortTable(
                        Array.from(headerRow.children).indexOf(th),
                        isAscending
                      );

                      sortIcon.src = isAscending
                        ? "./imgs/sort_asc.png"
                        : "./imgs/sort_desc.png";
                    });

                    headerRow.appendChild(th);
                  });
                  thead.appendChild(headerRow);
                  table.appendChild(thead);

                  function sortTable(columnIndex, isAscending) {
                    const rowsArray = Array.from(
                      tbody.getElementsByTagName("tr")
                    );
                    rowsArray.sort((rowA, rowB) => {
                      const cellA = rowA
                        .getElementsByTagName("td")
                        [columnIndex].textContent.trim();
                      const cellB = rowB
                        .getElementsByTagName("td")
                        [columnIndex].textContent.trim();

                      // Alphanumeric sorting for Part Numbers
                      if (isAscending) {
                        return cellA.localeCompare(cellB, undefined, {
                          numeric: true,
                          sensitivity: "base",
                        });
                      } else {
                        return cellB.localeCompare(cellA, undefined, {
                          numeric: true,
                          sensitivity: "base",
                        });
                      }
                    });

                    rowsArray.forEach((row) => tbody.appendChild(row));
                  }

                  function resetAllSortIcons() {
                    const sortIcons = document.querySelectorAll("th img");
                    sortIcons.forEach((icon) => {
                      icon.src = "./imgs/sort_asc.png";
                    });
                  }

                  function attachSortIconsEventListeners() {
                    const sortIcons = document.querySelectorAll("th img"); // Assuming sort icons are <img> elements within <th>
                    sortIcons.forEach((icon, index) => {
                      let isAscending = true;

                      icon.addEventListener("click", () => {
                        // Toggle sort order on each click
                        isAscending = !isAscending;

                        // Sort the table based on the current column and order
                        sortTable(index, isAscending);

                        // Update the sort icon to reflect the current sort order
                        icon.src = isAscending
                          ? "./imgs/sort_asc.png"
                          : "./imgs/sort_desc.png";
                      });
                    });
                  }

                  attachSortIconsEventListeners();

                  // Create table body
                  this.myTableData.values.forEach((rowData) => {
                    const shouldIncludeRow = rowData.some(
                      (value) => value !== false
                    );

                    if (shouldIncludeRow) {
                      row = document.createElement("tr");
                      const headersJSON = JSON.stringify(
                        this.myTableData.headers.map((header) => header.lbl)
                      );
                      row.setAttribute("data-headers", headersJSON);
                      rowData.forEach((value, index) => {
                        const td = document.createElement("td");
                        td.classList.add("dragTable-cell");
                        td.setAttribute(
                          "data-header",
                          this.myTableData.headers[index].lbl
                        );
                        // Check if the value is undefined or an empty string
                        if (value === undefined || value === "") {
                          td.textContent = ""; // Leave the cell empty
                        } else {
                          td.textContent = value;
                        }
                        row.appendChild(td);
                      });
                      this.isMouseOverRow = false;

                      let currentHoveredRow = null; // Track hovered row
                      let animationFrameId = null; // Track animation frame request

                      row.addEventListener("mouseover", async () => {
                        const clickedRowData = rowData;
                        const pnValue = clickedRowData[0];

                        // Track the latest hovered row
                        currentHoveredRow = pnValue;

                        // Cancel any pending animation frame request
                        if (animationFrameId) {
                          cancelAnimationFrame(animationFrameId);
                        }

                        // Use requestAnimationFrame to control when the image updates
                        animationFrameId = requestAnimationFrame(async () => {
                          try {
                            const partDataResponse =
                              await this.fetchFromDataVault(
                                "requestPart",
                                pnValue,
                                "partData"
                              );
                            const partDetails = (await partDataResponse.json())
                              .data;

                            // If the hovered row has changed, cancel the update
                            if (currentHoveredRow !== pnValue) return;

                            if (partDetails) {
                              const ffId = partDetails.ffId;

                              const formFactorDataResponse =
                                await this.fetchFromDataVault(
                                  "requestFormFactor",
                                  ffId,
                                  "formFactorData"
                                );
                              const formFactorData = (
                                await formFactorDataResponse.json()
                              ).data;

                              if (
                                formFactorData &&
                                formFactorData.images &&
                                formFactorData.images.length > 0
                              ) {
                                const imageInfo = formFactorData.images.find(
                                  (image) => image.imageURL.includes("/hyb/")
                                );

                                if (imageInfo) {
                                  let imgHeight = formFactorData.h * 48 + "px";
                                  let imgWidth = formFactorData.w * 48 + "px";

                                  // Adjust dimensions for specific part numbers
                                  if (specificPartNumbers.includes(pnValue)) {
                                    imgHeight =
                                      (formFactorData.h * 48) / 2 + "px";
                                    imgWidth =
                                      (formFactorData.w * 48) / 2 + "px";
                                  }

                                  const imageUrl = `${assetURL}${imageInfo.imageURL}`;
                                  const imagePreviewContainer =
                                    document.getElementById(
                                      "image-preview-container"
                                    );

                                  // **Check if user is still on this row**
                                  if (currentHoveredRow !== pnValue) return;

                                  // Clear previous images before appending a new one
                                  imagePreviewContainer.innerHTML = "";

                                  const imageElement =
                                    document.createElement("img");
                                  const catHeaderElement =
                                    document.getElementById("catHeader");
                                  const catHeaderHeight =
                                    catHeaderElement.offsetHeight;

                                  imageElement.src =
                                    await getCachedImage(imageUrl);

                                  imageElement.classList.add(
                                    "hover-image-preview"
                                  );
                                  imageElement.style.width = imgWidth;
                                  imageElement.style.height = imgHeight;
                                  imageElement.style.top = `${catHeaderHeight}px`;

                                  imagePreviewContainer.appendChild(
                                    imageElement
                                  );
                                  imagePreviewContainer.style.display = "block";
                                } else {
                                  log(
                                    "No appropriate image found in form factor data"
                                  );
                                }
                              } else {
                                log(
                                  "Form factor or images not found for",
                                  pnValue
                                );
                              }
                            } else {
                              log(
                                "Part number not found in part data:",
                                pnValue
                              );
                            }
                          } catch (error) {
                            console.error("Error fetching data:", error);
                          }
                        });
                      });

                      // **Ensure image disappears when user moves away**
                      row.addEventListener("mouseout", () => {
                        currentHoveredRow = null;

                        // Cancel pending animation frame to prevent rendering outdated images
                        if (animationFrameId) {
                          cancelAnimationFrame(animationFrameId);
                        }

                        const imagePreviewContainer = document.getElementById(
                          "image-preview-container"
                        );
                        imagePreviewContainer.innerHTML = "";
                        imagePreviewContainer.style.display = "none";
                      });
                      row.addEventListener("click", () => {
                        const clickedRowData = rowData;
                        log(rowData);
                        const headers = JSON.parse(
                          row.getAttribute("data-headers")
                        );
                        const properties = headers.reduce(
                          (obj, header, index) => {
                            obj[header] = clickedRowData[index] || "N/A";
                            return obj;
                          },
                          {}
                        );

                        console.log("Properties:", properties);

                        const pnValue = clickedRowData[0];
                        const mfgValue = clickedRowData[2];

                        const ffIdObject = data.data.pnToffId.find(
                          (pnToff) => pnToff.pn === pnValue
                        );
                        if (ffIdObject) {
                          const formFactor = data.data.formFactors.find(
                            (ff) => ff.ffIdx === ffIdObject.ffId
                          );
                          if (
                            formFactor &&
                            formFactor.images &&
                            formFactor.images.length > 0
                          ) {
                            this.partNumberVl = clickedRowData[0];
                            log(this.partNumberVl);
                            this.mfgNumber = mfgValue;
                            properties["FormFactor"] = formFactor.ffIdx;
                            const combinedUrl = `${assetURL}${formFactor.images[0].imageURL}`;

                            var combinedPurUrl =
                              formFactor.images[1] &&
                              formFactor.images[1].imageURL
                                ? `${assetURL}${formFactor.images[1].imageURL}`
                                : `${assetURL}${formFactor.images[0].imageURL}`;
                            const hw = formFactor.w;
                            const wh = formFactor.h;
                            const finder = hw / 2;
                            if (hw > wh) {
                              this.scaleH = wh / wh;
                              this.scaleW = hw / wh;
                            } else if (wh > hw) {
                              this.scaleH = wh / hw;
                              this.scaleW = hw / hw;
                            } else if (wh == hw) {
                              this.scaleH = wh / hw;
                              this.scaleW = hw / wh;
                            }
                            this.imageToUse = new Image();
                            this.imageToUse.src = combinedUrl;
                            this.imageToUsePur = new Image();
                            this.imageToUsePur.src = combinedPurUrl;

                            log(data.data.pnToffId, this.partNumberVl);
                            this.combinedHybridUrl = `${assetURL}${ffIdObject.imgURL}`;
                            this.layer = ffIdObject.layer;

                            const figure = {
                              partData: {
                                fullpartnumber: this.partNumberVl,
                                layer: ffIdObject.layer, // Adding the layer information here
                                properties: properties,
                              },
                              x: this.lastMouseup.x,
                              y: -1.5,
                              z: this.lastMouseup.z,
                              angle: 0, // Set the appropriate angle if needed
                            };
                            log(this.catId);

                            const xmdData = {
                              eventType: "add",
                              data: {
                                figures: [figure],
                              },
                            };
                            log("this is xmd data", xmdData);
                            this.eventHub.emit("MakePartsEvent", xmdData); // Emit the makeParts event with the data

                            log(this.modeValue);

                            this.layoutTexture = new THREE.TextureLoader().load(
                              this.imageToUse.src
                            );
                            this.layoutTexture.src = combinedUrl;

                            this.purTexture = new THREE.TextureLoader().load(
                              this.imageToUsePur.src
                            );
                          } else {
                            log("Form factor or images not found for", pnValue);
                          }
                        } else {
                          log("Part number not found in pnToffId:", pnValue);
                        }
                        filterDiv.style.display = "none"; // Hide search
                        this.dragTableContainer.style.display = "none";
                        filterInput.value = ""; // Clear the input value
                        filterTable();
                        const imagePreviewContainer = document.getElementById(
                          "image-preview-container"
                        );

                        imagePreviewContainer.style.display = "none";
                        table.style.display = "None";
                        this.tableIsHere = false;
                        this.isMouseOverRow = true;
                      });

                      tbody.appendChild(row);
                    }
                  });
                  table.appendChild(tbody);
                  this.updateBackgroundContainer();
                  sortTable(0, true);
                })
                .catch((error) => {
                  console.error("Error:", error);
                });

              function reportError(error, pn, idCat, partNum, ffIder) {
                const errorUrlForSend = errorUrl;
                const urlForPn = `${errorUrlForSend}/${pn}`;

                // Prepare the error report
                const errorReport = {
                  categoryId: idCat,
                  partNumber: partNum,
                  ffId: ffIder,
                  message: error.message, // Or any other information you want to include
                  // Include other relevant data for the error report
                };
                // Send the error report
                this.fetchWithAuthHeaders(urlForPn, {
                method: "POST",
                body: JSON.stringify(errorReport)
              })

                  .then((response) => {
                    if (!response.ok) {
                      // Handle errors when sending the error report
                      console.error(
                        `Error reporting failed with status: ${response.status}`
                      );
                    } else {
                    }
                  })
                  .catch((error) => {
                    console.error("Error reporting fetch failed:", error);
                  });
              }

              function modifySvgContent(originalSvgContent, newDocName) {
                const viewBoxMatch =
                  originalSvgContent.match(/viewBox="([^"]+)"/);

                let width, height;

                if (viewBoxMatch) {
                  const viewBoxValues = viewBoxMatch[1].split(" ");
                  width = viewBoxValues[2]; // The third value in viewBox is the width
                  height = viewBoxValues[3]; // The fourth value in viewBox is the height
                } else {
                  width = "100%";
                  height = "100%";
                }

                const newSvgOpeningTag = `<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" viewBox="${
                  viewBoxMatch ? viewBoxMatch[1] : ""
                }" width="${width}" height="${height}" version="1.1" inkscape:version="0.92.3 (2405546, 2018-03-11)" sodipodi:docname="${newDocName}">`;

                // Replace the original <svg> opening tag with the new one
                const modifiedSvgContent = originalSvgContent.replace(
                  /<svg[^>]+>/,
                  newSvgOpeningTag
                );
                return modifiedSvgContent;
              }

              // Calculate the offset between the mouse click and the top-left corner of the original button
              const offsetX =
                event.clientX - categoryButton.getBoundingClientRect().left;
              const offsetY =
                event.clientY - categoryButton.getBoundingClientRect().top;
              // Create a copy of the button or icon
              var copy = categoryButton.cloneNode(true);
              copy.style.position = "absolute";
              copy.style.zIndex = "1000"; // Ensure the copy is above other elements
              copy.style.width = "50px";
              copy.style.height = "50px";
              document.body.appendChild(copy);

              // Set the initial position of the copy to match the mouse click
              copy.style.left = event.clientX - offsetX + "px";
              copy.style.top = event.clientY - offsetY + "px";

              const handleMouseMove = (moveEvent) => {
                this.mouseOnBtn = true;

                // Move the copy along with the mouse, considering the offset
                copy.style.left = moveEvent.clientX - offsetX + "px";
                copy.style.top = moveEvent.clientY - offsetY + "px";
                const basePlane = this.experience.world.basePlane.mesh; // Get BasePlane mesh
                const intersects = this.raycaster.intersectObject(
                  basePlane,
                  true
                ); // Only check BasePlane

                if (intersects.length > 0) {
                  log("intersects", intersects[0]);
                  // If there's an intersection, update your Object3D position
                  const intersectPoint = intersects[0].point;
                  this.lastMouseup.copy(intersectPoint);
                  var newX = Math.floor(intersectPoint.x);
                  var newZ = Math.floor(intersectPoint.z);
                  this.lastMouseup.set(newX, intersectPoint.y, newZ);
                  /*                   lastMouseup.x = newX;
                  lastMouseup.z = newZ; */
                  this.buttonDrag = false;
                }
              };
              const handleMouseUp = () => {
                // Remove event listeners
                document.removeEventListener("mousemove", handleMouseMove);
                document.removeEventListener("mouseup", handleMouseUp);
                // Check if the copy is over a valid position
                this.mouse.x =
                  (event.clientX / this.sizes.reSize.width) * 2 - 1;
                this.mouse.y =
                  -(event.clientY / this.sizes.reSize.height) * 2 + 1;
                this.raycaster.setFromCamera(this.mouse, this.camera.instance);
                this.intersect = this.raycaster.intersectObjects(
                  this.scene.children
                );

                if (this.intersect.length > 0) {
                  const intersectionPoint = this.intersect[0].point;
                  document.body.removeChild(copy);
                } else {
                  document.body.removeChild(copy);
                }
                if (this.catId === "TBX") {
                  this.eventHub.emit("TextBoxEvent", {
                    eventType: "add",
                    data: {
                      others: [
                        {
                          x: this.lastMouseup.x,
                          z: this.lastMouseup.z,
                        },
                      ],
                    },
                  });
                  log(
                    { x: this.lastMouseup.x, z: this.lastMouseup.z },
                    "CALLED TEXT BOX"
                  );
                }
                // Reset the copy variable
                copy = null;
              };

              // Add event listeners for mouse move and mouse up
              document.addEventListener("mousemove", handleMouseMove);
              document.addEventListener("mouseup", handleMouseUp);
            });
            tabContent.appendChild(categoryButton);
          }

          // Add event listener for tabButton click
          tabButton.addEventListener("click", (ev) => {
            let tabContents = document.querySelectorAll(".tab-content");
            for (let i = 0; i < tabContents.length; i++) {
              tabContents[i].style.display = "none";
            }
            if (document.querySelector(".tabButton.active")) {
              document
                .querySelector(".tabButton.active")
                .classList.remove("active");
            }
            ev.target.classList.add("active");
            document.getElementById(
              ev.target.getAttribute("referenced-tab")
            ).style.display = "flex";
          });
          document
            .getElementById("tabs-content-container")
            .appendChild(tabContent);
        }
      } catch (error) {
        console.error("Error fetching tabs data:", error);
      }
    })();
    document.body.appendChild(table);

    const closeButton = document.createElement("button");
    closeButton.textContent = "Close Table";
    closeButton.style.position = "absolute";
    closeButton.style.top = "90%"; // Adjust the position based on your design
    closeButton.style.left = "45%"; // Adjust the position based on your design

    // Add an event listener to the close button
    closeButton.addEventListener("click", () => {
      const closeTable = document.querySelector(".drag-table");
      if (closeTable) {
        closeTable.style.display = "none";
      }
      this.tableIsHere = false;
      this.scene.remove(this.group);
    });
    this.canvas.addEventListener("click", (event) => {
      document.getElementById("image-preview-container").innerHTML = "";
      this.globalTableContainer.hideGlobalTableContainer();
      if (document.getElementById("infoModal")) {
        document.getElementById("infoModal").style.display = "none";
      }
      if (this.modal) {
        this.modal.style.display = "none";
      }
      const modal = document.getElementById("confModal");
      if (event.button !== 0) return; // Exit if not left click
      if (modal) {
        modal.style.display = "none";
        // You may also want to remove it from the DOM entirely
        document.body.removeChild(modal);
      }
      if (this.tableIsHere == true) {
        table.style.display = "none";
        filterDiv.style.display = "none"; // Hide search
        this.dragTableContainer.style.display = "none";
        filterInput.value = ""; // Clear the input value
        filterTable();
      }
    });

    window.objectsInScene = this.objects;
    window.addEventListener("loadSavedDesign", (event) => {
      this.loadScene();
    });

    window.addEventListener("mousemove", (event) => {
      if (event.button !== 0) return; // Exit if not left click

      this.mouse.x = (event.clientX / this.sizes.reSize.width) * 2 - 1;
      this.mouse.y = -(event.clientY / this.sizes.reSize.height) * 2 + 1;
      this.raycaster.setFromCamera(this.mouse, this.camera.instance);
      this.intersects = this.raycaster.intersectObjects(this.scene.children);
      if (this.haha == true && this.clone) {
        if (this.intersects.length > 0) {
          const intersectionPoint = this.intersects[0].point;
          const targetX = intersectionPoint.x;
          const targetZ = intersectionPoint.z;
          this.plane1 = intersectionPoint.x;
          this.plane1 = intersectionPoint.z;
        }
      }
    });

    this.connectedObjects = [];
    this.connectedForMiniPad = [];
    this.instances = [];
    this.instancesPads = [];
    this.gltfInstances = [];
    this.newConnectionMade = false;
    this.gsgs = [];
    this.copiedMesh = null;
    this.selectedMesh = null;
    let mouseDown;
    document.body.addEventListener("mouseup", (event) => {
      if (event.button !== 0) return; // Exit if not left click

      this.haha = false;
      mouseDown = false;

      if (this.mouseOnBtn == true) {
        table.style.display = "block";
        filterDiv.style.display = "flex"; // Make search visible
        this.dragTableContainer.style.display = "block";
        filterDiv.style.justifyContent = "center";
        this.tableIsHere = true;
        this.mouseOnBtn = false;
        if (this.catId === "TBX") {
          table.style.display = "none";
          this.dragTableContainer.style.display = "none";
        }
        const tableRect = table.getBoundingClientRect();

        const filterDivHeight = filterDiv.offsetHeight;
        filterDiv.style.position = "fixed";
        filterDiv.style.zIndex = "9999";
        filterDiv.style.width = "230px";
        const additionalOffset = 10;
        filterDiv.style.top =
          tableRect.top - filterDivHeight - additionalOffset + "px";
        filterDiv.style.left = `${tableRect.left}px`;
        buttonContainer.style.left = `${
          filterDiv.getBoundingClientRect().left + 20
        }px`;
        this.updateBackgroundContainer();
      }
    });

    window.addEventListener("resize", this.updateBackgroundContainer);
    tabsContainer.appendChild(this.dragTableContainer);
    table.insertAdjacentElement("beforebegin", this.dragTableContainer);

    this.selectedGroup = null;
    this.toDisableMove = null;
    let collisionDetected = false;
    let rotationStateRadians = 0;

    // triggering
    this.eventHub.on("globalContextMenu", (event) => {
      const selectedObjects = Array.from(this.experience.selectedObjects);
      if (selectedObjects.length === 0) return;

      const selectedObject = selectedObjects[0];
      window.selectedForCM = selectedObject;
      
      // Debug: Log what we're setting as selectedForCM
      log("[DEBUG] Setting window.selectedForCM:", selectedObject);
      log("[DEBUG] Selected object parent userData:", selectedObject.parent?.userData);
      log("[DEBUG] Selected object category:", selectedObject.parent?.userData?.category);
      
      if (selectedObject.userData.mode !== "textbox") {
        this.selectedForContextMenu = selectedObject;
        log("selectd objects", selectedObject);
        log("event", event);
        log("partnumber", selectedObject.userData);
        this.eventHub.emit("rightClickContextMenu", {
          x: event.clientX,
          y: event.clientY,
          partNumber: selectedObject.userData.partNumber,
        });
      } else {
        this.eventHub.emit("rightClickTextBox", {
          others: selectedObject.userData,
          mesh: selectedObject,
        });
      }
    });

    // Add a mouse up event listener to stop dragging
    window.addEventListener("mouseup", (event) => {
      if (event.button !== 0) return; // Exit if not left click
      this.isDragging = false;
      this.selectedGroup = null;
      this.toDisableMove = null;
      document.body.style.cursor = "auto";
      this.isDrag = false;
      if (collisionDetected) {
        this.scene.remove(this.selectedGroup);
      }
    });

    document.body.appendChild(table);

    // Append the close button to the document
    this.eventHub.on("globalContextMenu", (event) => {
      log("globalContextMenu - closing modal", event);
      event.preventDefault();
      document.dispatchEvent(new CustomEvent("closeModal"));
      if (this.modal && this.modal.style.display === "block") {
        document.body.removeChild(this.modal);
        this.modal = null;
      }
    });

    window.addEventListener("mousedown", (event) => {
      if (event.button !== 0) return; // Exit if not left click
      mouseDown = true;
    });

    // Ensure image preview is cleared if the user exits the table too quickly
    this.dragTableContainer.addEventListener("mouseleave", () => {
      const imagePreviewContainer = document.getElementById("image-preview-container");
      if (imagePreviewContainer) {
        imagePreviewContainer.innerHTML = "";
        imagePreviewContainer.style.display = "none";
      }
    });

    this.copiedMeshAndTexture = []; // Clear the previous array
  }

  showFirstVisitUpdateModalIfNeeded() {
    try {
      if (getViewDesignSourceFromPath() === "admin") {
        return;
      }

      const existingPreference = getCookie(UPDATE_MODAL_COOKIE_NAME);
      if (existingPreference === "hidden") {
        return;
      }

      if (!this.eventHub) {
        return;
      }

      this.eventHub.emit("modalInfo", {
        variant: "3d-highlight",
        headerImage: "./imgs/3d_view.png",
        title: "3D View Is Now Live!",
        messageHtml: `<p>You can now explore your new and existing layouts in an all new interactive 3D view.</p><p>Switch to 3D to:</p><ul><li>Visualize depth and spatial relationships</li><li>Inspect top side RF or bottom side control</li><li>Experience your design in a more realistic environment.</li></ul>`,
        showDontShowAgainToggle: true,
        dontShowAgainLabel: "Don't show this message again",
        actions: [
          {
            label: "Close",
            primary: true,
            callback: () => {
              const checkbox = document.querySelector(
                ".global-modal-toggle-checkbox"
              );
              if (checkbox && checkbox.checked) {
                setCookie(UPDATE_MODAL_COOKIE_NAME, "hidden", 365);
              }
            },
          },
        ],
      });
    } catch (error) {
      log("Error showing first-visit update modal:", error);
    }
  }

  /**
   * Clears meshAndTexture and meshAndPurTexture arrays and disposes custom textures.
   * Prevents memory leak when switching 2D/3D mode (deleteScene + reload).
   */
  clearMeshAndTextureOnDelete() {
    const disposeTexture = (tex) => {
      if (tex && typeof tex.dispose === "function") tex.dispose();
    };
    [...this.meshAndTexture, ...this.meshAndPurTexture].forEach((entry) => {
      if (entry) {
        disposeTexture(entry.layoutTexture);
        disposeTexture(entry.hybridTexture);
        disposeTexture(entry.purTexture);
      }
    });
    this.meshAndTexture = [];
    this.meshAndPurTexture = [];
  }

  handleMessage(data) {
    [...this.meshAndTexture, ...this.meshAndPurTexture].forEach((entry) => {
      if (data === "layout") {
        this.layoutMode = "layout";
        entry.mesh.material.map = entry.hybridTexture;
        this.scene.traverse((object) => {
          if (object.userData.type === "textGeometry") {
            object.visible = false;
          }
        });
      } else if (data === "hybrid") {
        this.scene.traverse((object) => {
          if (object.userData.type === "textGeometry") {
            object.visible = true;
          }
        });
        entry.mesh.material.map = entry.layoutTexture;
        this.layoutMode = "hybrid";
      }
      entry.mesh.material.needsUpdate = true;
    });
  }
  

  zoomCameraToFitScene(fitOffset = 1.2) {
    const boundingBox = new THREE.Box3();

    // Calculate bounding box of all visible mesh objects
    this.scene.traverse((object) => {
      if (object.isMesh && object.visible) {
        boundingBox.expandByObject(object);
      }
    });

    const center = boundingBox.getCenter(new THREE.Vector3());
    const size = boundingBox.getSize(new THREE.Vector3());

    // Determine the distance the camera should be based on the size of the bounding box
    const maxDim = Math.max(size.x, size.y, size.z);
    const cameraDistance =
      maxDim / (2 * Math.atan((Math.PI * this.camera.instance.fov) / 360));

    // Adjust the camera to look from top-down
    this.camera.instance.position.x = center.x;
    this.camera.instance.position.y = center.y;
    this.camera.instance.position.z = cameraDistance * fitOffset; // Move the camera out by the fitOffset factor
    this.camera.instance.up.set(0, 0, -1); // Ensure that the camera's "up" is now facing the opposite direction

    // Point the camera down
    this.camera.instance.lookAt(center.x, center.y, center.z);

    // Update the camera projection matrix
    this.camera.instance.updateProjectionMatrix();

    // If using OrbitControls or similar, update the target and possibly disable rotation
    if (this.camera.controls) {
      this.camera.controls.target.set(center.x, center.y, center.z);
      this.camera.controls.enableRotate = false; // Disable orbit controls rotation
      this.camera.controls.update();
    }
  }

  openDatabase() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open("ImageCacheDB", 1);

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onerror = (event) => {
        reject("IndexedDB error: " + event.target.error);
      };
    });
  }

  /**
   * Opens the IndexedDB database and returns a promise for the database connection.
   * @returns {Promise<IDBDatabase>}
   */

  /**
   * Retrieves cached data from IndexedDB.
   * @param {string} key - The key to retrieve from IndexedDB.
   * @param {string} storeName - The IndexedDB store name.
   * @returns {Promise<Object|null>} - A promise that resolves to the stored object or null if not found.
   */
  getCachedData(key, storeName) {
    return this.openDatabase().then((db) => {
      return new Promise((resolve, reject) => {
        const transaction = db.transaction(storeName, "readonly");
        const store = transaction.objectStore(storeName);
        const request = store.get(key);

        request.onsuccess = () => {
          if (request.result) {
            //console.log(`Retrieved data from IndexedDB: ${storeName}, Key: ${key}`);
          }
          resolve(request.result || null);
        };

        request.onerror = () => {
          reject(
            `Error retrieving data from IndexedDB: ${storeName}, Key: ${key}`
          );
        };
      });
    });
  }

  showConfModal(headers) {
    const modal = document.createElement("div");
    modal.id = "confModal";
    modal.classList.add("tableConfModal");
    modal.style.position = "fixed";
    modal.style.left = "50%";
    modal.style.top = "50%";
    modal.style.transform = "translate(-50%, -50%)";
    modal.style.width = "500px";
    modal.style.height = "auto";
    modal.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
    modal.style.borderRadius = "10px";
    modal.style.padding = "20px";
    modal.style.zIndex = "10000";
    modal.style.overflowY = "auto";

    const modalButtonContainer = document.createElement("div");
    modalButtonContainer.style.display = "flex";
    modalButtonContainer.style.marginTop = "20px";

    const modalBtnXMW = document.createElement("button");
    modalBtnXMW.classList.add("table-configurable-xmwBtn");
    modalBtnXMW.textContent = "X-MWBlock";

    modalBtnXMW.addEventListener("click", () => {
      closeModal();
      this.dragTableContainer.style.display = "block";
      document.getElementById("image-preview-container").innerHTML = "";
      table.style.display = "block";
    });

    const modalBtnConfig = document.createElement("button");
    modalBtnConfig.classList.add("table-configurable-cfgBtn");
    modalBtnConfig.textContent = "Configurable";

    modalButtonContainer.appendChild(modalBtnXMW);
    modalButtonContainer.appendChild(modalBtnConfig);

    modal.appendChild(modalButtonContainer);

    const buttonContainer = document.createElement("div");
    buttonContainer.style.display = "flex";
    buttonContainer.style.justifyContent = "space-between";
    buttonContainer.style.marginTop = "20px"; // Space from the last input

    const resetButton = document.createElement("button");
    resetButton.textContent = "RESET";
    resetButton.style.padding = "10px 20px";
    resetButton.style.border = "none";
    resetButton.style.borderRadius = "5px";
    resetButton.style.backgroundColor = "#FFA400";
    resetButton.style.color = "white";
    resetButton.style.cursor = "pointer";
    resetButton.addEventListener("click", function () {
      // Reset text inputs
      const textInputs = modal.querySelectorAll('input[type="text"]');
      textInputs.forEach((input) => (input.value = ""));

      // Reset number inputs
      const numberInputs = modal.querySelectorAll('input[type="number"]');
      numberInputs.forEach((input) => (input.value = ""));

      // Reset select to its first option
      const selects = modal.querySelectorAll("select");
      selects.forEach((select) => {
        select.selectedIndex = 0;
        select.dispatchEvent(new Event("change"));
      });
    });

    const configureButton = document.createElement("button");
    configureButton.textContent = "SAVE";
    configureButton.style.padding = "10px 20px";
    configureButton.style.border = "none";
    configureButton.style.borderRadius = "5px";
    configureButton.style.backgroundColor = "#004976";
    configureButton.style.color = "white";
    configureButton.style.cursor = "pointer";

    configureButton.addEventListener("click", () => {
      const selectedOption = select.options[select.selectedIndex];
      log(selectedOption.text);
      const modalData = {
        figures: [
          {
            partData: {
              mode: "user-cfg",
              fullpartnumber: "",
              ffId: selectedOption.value,
              layer: 30,
              properties: {},
            },
            x: this.lastMouseup.x || 2,
            y: -1.5,
            z: this.lastMouseup.z || 3,
            angle: 0,
          },
        ],
      };
      const inputs = modal.querySelectorAll("input");
      inputs.forEach((input) => {
        const property = input.placeholder; // Assuming the placeholder has the property name
        modalData.figures[0].partData.properties[property] =
          input.value.trim() || null;
      });
      modalData.figures[0].partData.fullpartnumber =
        modalData.figures[0].partData.properties["Part Number"];
      this.eventHub.emit("MakePartsEvent", {
        eventType: "add",
        data: modalData,
      });

      if (selectedOption && selectedOption.value) {
        modalData.figures[0].partData.properties["FormFactor"] =
          selectedOption.value;

        // Find the form factor by ffId
        const ffId = selectedOption.value;
        const selectedFfid = this.myTableData.formFactors.find(
          (f) => f.ffIdx === ffId
        );
      }

      document.getElementById("confModal").style.display = "none";
      document.getElementById("image-preview-container").innerHTML = "";
      log(modalData, "CONFIGURED DATA");
    });
    const selectContainer = document.createElement("div");
    selectContainer.style.display = "flex";
    selectContainer.style.justifyContent = "space-between";
    selectContainer.style.alignItems = "center";
    selectContainer.style.marginTop = "2px !important";

    const formFactorLabel = document.createElement("label");
    formFactorLabel.classList.add("ffLabel");
    formFactorLabel.textContent = "Form Factor";
    formFactorLabel.style.marginRight = "10px";

    selectContainer.appendChild(formFactorLabel);

    const select = document.createElement("select");
    select.classList.add("ffSelect");
    select.style.width = "100%";
    select.style.padding = "5px";
    select.style.marginTop = "5px";

    selectContainer.appendChild(select);

    this.myTableData.ffIdx.forEach((item) => {
      const option = document.createElement("option");
      option.value = item.ffId;
      option.textContent = item.tag;
      select.appendChild(option);
    });

    select.addEventListener("change", async function () {
      const selectedFfId = this.value;

      if (selectedFfId) {
        try {
          //console.log(`[FormFactor] Selected form factor: ${selectedFfId}`);

          // Retrieve form factor data from IndexedDB
          const formFactorData = await getCachedData(
            selectedFfId,
            "formFactors"
          );

          if (
            !formFactorData ||
            !formFactorData.images ||
            formFactorData.images.length === 0
          ) {
            console.warn(
              `[FormFactor] No data or images found for: ${selectedFfId}`
            );
            return;
          }

          // Find the correct image (CFG type preferred)
          const cfgImage =
            formFactorData.images.find((image) => image.imageType === "CFG") ||
            formFactorData.images[1];

          if (cfgImage) {
            const imageKey = cfgImage.imageURL;
            const formattedImageKey = `/cascade${imageKey}`;

            console.log(`[ImageCache] Looking for image: ${formattedImageKey}`);

            // Retrieve the image from IndexedDB
            const imageUrl = await getCachedImage(formattedImageKey);

            if (!imageUrl) {
              console.warn(
                `[ImageCache] Image not found in IndexedDB: ${formattedImageKey}`
              );
            } else {
              console.log(
                `[ImageCache] Loaded image from IndexedDB: ${formattedImageKey}`
              );
            }

            const imagePreviewContainer = document.getElementById(
              "image-preview-container"
            );
            imagePreviewContainer.innerHTML = "";

            const imageElement = document.createElement("img");
            imageElement.src = imageUrl;
            imageElement.classList.add("hover-image-preview");

            let imgHeight = formFactorData.h * 48 + "px";
            let imgWidth = formFactorData.w * 48 + "px";

            // Adjust dimensions for specific part numbers or form factors
            if (
              specificPartNumbers.includes(selectedFfId) ||
              specificFormFactors.includes(selectedFfId)
            ) {
              imgHeight = (formFactorData.h * 48) / 2 + "px";
              imgWidth = (formFactorData.w * 48) / 2 + "px";
            }

            imageElement.style.width = imgWidth;
            imageElement.style.height = imgHeight;

            imagePreviewContainer.appendChild(imageElement);
            imagePreviewContainer.style.display = "block";

            const catHeaderElement = document.getElementById("catHeader");
            const catHeaderHeight = catHeaderElement.offsetHeight;

            imageElement.style.position = "absolute";
            imageElement.style.top = `${catHeaderHeight}px`;
          }
        } catch (error) {
          console.error(
            "[ImageCache] Error retrieving form factor details from IndexedDB:",
            error
          );
        }
      }
    });

    select.selectedIndex = 0;
    select.dispatchEvent(new Event("change"));

    function showInfoMessage(input, message) {
      let existingMessage = input.parentNode.querySelector(".info-message");
      if (existingMessage) {
        input.parentNode.removeChild(existingMessage);
      }

      let infoMessage = document.createElement("div");
      infoMessage.textContent = message;
      infoMessage.className = "info-message";
      infoMessage.style.color = "red";
      infoMessage.style.marginTop = "4px";
      input.parentNode.appendChild(infoMessage);
    }

    modal.addEventListener("input", function (event) {
      let target = event.target;
      if (target.type === "number") {
        target.value = target.value.replace(/[^0-9.]/g, "");

        if (/[^0-9.]/.test(target.value)) {
          showInfoMessage(target, "Please enter a number.");
        } else {
          let existingMessage =
            target.parentNode.querySelector(".info-message");
          if (existingMessage) {
            target.parentNode.removeChild(existingMessage);
          }
        }
      }
    });

    headers.forEach((header) => {
      if (header.lbl.toLowerCase() !== "price (usd)") {
        const inputGroup = document.createElement("div");
        inputGroup.className = "inputGroup";
        inputGroup.style.display = "flex";
        inputGroup.style.justifyContent = "space-between";
        inputGroup.style.alignItems = "center";
        inputGroup.style.marginTop = "5px";

        const label = document.createElement("label");
        label.textContent = header.lbl;
        label.style.marginRight = "10px";

        const input = document.createElement("input");
        if (
          ["part number", "manufacturer", "manufacturer part number"].includes(
            header.lbl.toLowerCase()
          )
        ) {
          input.type = "text";
        } else {
          input.type = "number";
          input.addEventListener("input", function () {
            if (this.value.length) {
              this.value = this.value.replace(/[^0-9.]/g, "");
              if (/[^0-9.]/.test(this.value)) {
                showInfoMessage(this, "Please enter a number.");
              } else {
                let existingMessage =
                  this.parentNode.querySelector(".info-message");
                if (existingMessage) {
                  this.parentNode.removeChild(existingMessage);
                }
              }
            }
          });
        }
        input.placeholder = header.lbl;
        input.style.flex = "1";
        input.style.padding = "5px";

        inputGroup.appendChild(label);
        inputGroup.appendChild(input);
        document.body.appendChild(modal);
        modal.appendChild(inputGroup);
      } else {
      }
    });

    buttonContainer.appendChild(resetButton);
    buttonContainer.appendChild(configureButton);
    modal.appendChild(selectContainer);
    modal.appendChild(buttonContainer);

    function closeModal() {
      if (document.body.contains(modal)) {
        document.body.removeChild(modal);
      }
      document.removeEventListener("click", pageClickHandler);
    }

    function pageClickHandler(event) {
      if (
        !modal.contains(event.target) &&
        event.target !== modalButtonContainer
      ) {
        closeModal();
      }
    }

    document.addEventListener("click", pageClickHandler, true);
    document.body.appendChild(modal);
  }

  updateBackgroundContainer() {
    const tableRect = table.getBoundingClientRect();
    if (this.dragTableContainer) {
      this.dragTableContainer.style.width = `${tableRect.width + 30}px`;
      this.dragTableContainer.style.height = `${tableRect.height + 60}px`;
      this.dragTableContainer.style.top = `${tableRect.top - 45}px`;
      this.dragTableContainer.style.left = `${tableRect.left - 15}px`;
    }
  }

  cleanup() {
    // Remove event listeners
    window.removeEventListener("mousemove", this.updateMousePosition);
    window.removeEventListener("resize", this.updateBackgroundContainer);
    window.removeEventListener("mouseup", this.onMouseUp);
    window.removeEventListener("mousedown", this.onMouseDown);
    window.removeEventListener("loadSavedDesign", this.loadScene);
    document.body.removeEventListener("mouseup", this.onMouseUp);
    document.removeEventListener("click", this.pageClickHandler, true);

    // Remove global event listeners
    if (this.eventHub) {
      this.eventHub.off("globalContextMenu", this.handleGlobalContextMenu);
      this.eventHub.off("rightClickContextMenu");
      this.eventHub.off("rightClickTextBox");
      this.eventHub.off("MakePartsEvent");
      this.eventHub.off("deleteScene", this._clearMeshAndTextureOnDelete);
    }

    // Remove elements from DOM
    if (this.dragTableContainer) {
      this.dragTableContainer.remove();
      this.dragTableContainer = null;
    }

    if (this.table) {
      this.table.remove();
      this.table = null;
    }

    if (this.modal) {
      this.modal.remove();
      this.modal = null;
    }

    // Clear Three.js scene objects
    if (this.scene) {
      while (this.scene.children.length > 0) {
        const object = this.scene.children[0];
        this.scene.remove(object);
        if (object.geometry) object.geometry.dispose();
        if (object.material) {
          if (Array.isArray(object.material)) {
            object.material.forEach((mat) => mat.dispose());
          } else {
            object.material.dispose();
          }
        }
      }
    }

    // Dispose textures
    this.meshAndTexture.forEach((entry) => {
      if (entry.mesh) {
        this.scene.remove(entry.mesh);
        if (entry.mesh.geometry) entry.mesh.geometry.dispose();
        if (entry.mesh.material) entry.mesh.material.dispose();
      }
    });
    this.meshAndTexture = [];

    // Dispose renderer
    if (this.renderer) {
      this.renderer.dispose();
    }

    // Nullify references to prevent memory leaks
    this.objects = [];
    this.objectsToMove = [];
    this.connectionPoints = [];
    this.objectsAndPlane = [];
    this.originalMaterials = [];
    this.meshAndTexture = [];
    this.meshAndPurTexture = [];
    this.Meshes = [];
    this.housings = [];
    this.ctlMeshes = [];
    this.housingsAndPlane = [];
    this.ctlToGroupMap.clear();

    this.selectedGroup = null;
    this.toDisableMove = null;
    this.selectedForContextMenu = null;
    this.mouseOnBtn = false;
    this.isDragging = false;
    this.stopClickOnCt = false;
    this.blockSingleDrag = false;
    this.tableIsHere = false;

    // Destroy instantiated classes
    if (this.makeGsg) this.makeGsg = null;
    if (this.detectCollisionGsg) this.detectCollisionGsg = null;
    if (this.makeControls) this.makeControls = null;
    if (this.makeWalls) this.makeWalls = null;
    if (this.makeLids) this.makeLids = null;
    if (this.textBoxManager) this.textBoxManager = null;
    if (this.deleteAuto) this.deleteAuto = null;
    if (this.deleteObject) this.deleteObject = null;
    if (this.contextMenu) this.contextMenu = null;
    if (this.copyPasteManager) this.copyPasteManager = null;
    if (this.darkModeController) this.darkModeController = null;
    if (this.Destroy) this.Destroy = null;

    // Ensure IndexedDB connection is closed
    if (this.dbConnection) {
      this.dbConnection.close();
      this.dbConnection = null;
    }

    log("Functions instance cleaned up.");
  }

  async fetchWithAuthHeaders(url, options = {}) {
  return new Promise((resolve) => {
    this.eventHub.emit("tokenRequest");
    this.eventHub.once("tokenResponse", async (token) => {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
        ...(options.headers || {})
      };

      try {
        const response = await fetch(url, {
          ...options,
          headers
        });

        resolve(response);
      } catch (err) {
        console.error(`[Functions] Auth fetch failed: ${err.message}`);
        resolve({ ok: false, status: 500, json: async () => ({ error: err.message }) });
      }
    });
  });
}

}
